/* eslint-disable import/no-extraneous-dependencies */
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbDropdown, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsModule } from '@ngxs/store';
import 'hammerjs';
import { AuthenticationModule } from 'projects/authentication/src/app/app.module';
import { AuthenticationInterceptorService } from 'projects/authentication/src/app/services/interceptors';
import { Common2Module } from 'projects/common/src/app/app.module';
import { CommunicationModule } from 'projects/communication/src/app/app.module';
import { ErrorInterceptorService } from 'projects/communication/src/app/services/interceptors';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingBaseAppComponent } from './components/loading-base-app/loading-base-app.component';
import { CoreModule, DashboardModule, LayoutModule, LoginModule, ReportModule, SidebarModule } from './modules';
import { TimePresentationPipe } from './modules/core/pipes/time-presentation.pipe';
import { NavigationService } from './modules/core/services/navigation.service';
import { DashboardState } from './modules/core/store/dashboard/dashboard.state';
import { DateState } from './modules/core/store/date/date.state';
import { MessengerState } from './modules/core/store/messenger/messenger.state';
import {
  authenticationServiceProvider,
  communicationSecurityServiceProvider,
  languageCollectionServiceProvider,
  shiftCollectionServiceProvider,
  tokenServiceProvider,
} from './services/providers';
import { StartService } from './services/start.service';

declare const Hammer: any;

export class MyHammerConfig extends HammerGestureConfig {
  buildHammer(element: HTMLElement) {
    const mc = new Hammer(element, {
      touchAction: 'pan-y',
    });
    return mc;
  }
}

@NgModule({
  declarations: [AppComponent, LoadingBaseAppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DashboardModule,
    LayoutModule,
    ReportModule,
    CoreModule,
    LoginModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    Common2Module.forRoot(),
    CommunicationModule.forRoot(),
    AuthenticationModule.forRoot(),
    SidebarModule,
    NgbModule,
    NgxsModule.forRoot([DashboardState, DateState, MessengerState], { developmentMode: environment.production === false }),
    NgxsLoggerPluginModule.forRoot({ disabled: !environment.reduxLogger }),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production !== false }),
  ],
  exports: [],
  providers: [
    TimePresentationPipe,
    NgbDropdown,
    communicationSecurityServiceProvider,
    languageCollectionServiceProvider,
    shiftCollectionServiceProvider,
    authenticationServiceProvider,
    tokenServiceProvider,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfig: StartService) => () => appConfig.init(),
      deps: [StartService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfig: NavigationService) => () => appConfig.init(),
      deps: [NavigationService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
